import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
    },
    templateOption: {
      '& .MuiListItemText-secondary': {
        whiteSpace: 'pre-wrap',
      },
    },
  };
};
